import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import DashboardHeader from './components/HeaderACV';
import TabellaCilindri from './components/TabellaCilindri';
import OrizonFooter from './components/OrizonFooter';
import Icon from '../../components/AppIcon';
import NewInsert_Cilindri from './components/NewInsert_Cilindri';
import LineeOverviewModal from './components/LineeOverview'; 
import GraficiPanieraModal from './components/GraficiPaniera';
import ScortaCilindriModal from './components/ScortaCilindri';

// --- TOLLTIP COMPONENTA (za čišći kod) ---
const ActionButton = ({ onClick, icon, label, description, colorClass, disabled = false, isLoading = false }) => (
  <div className="relative group flex items-center">
    {/* TOOLTIP: Pojavljuje se na hover iznad dugmeta */}
    <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-3 px-3 py-1.5 bg-black/80 backdrop-blur-md text-white text-[9px] font-bold uppercase tracking-widest rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none whitespace-nowrap z-[100] border border-white/10 shadow-xl">
      {description}
      {/* Mali trougao na dnu tooltipa */}
      <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-black/80" />
    </div>

    <button 
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center gap-2 px-4 py-4 md:px-6 md:py-3.5 rounded-2xl text-white transition-all shadow-lg group active:scale-95 disabled:opacity-50 ${colorClass}`}
    >
      {isLoading ? (
        <Icon name="Loader2" size={20} className="animate-spin" />
      ) : (
        <Icon name={icon} size={20} className="group-hover:scale-110 transition-transform duration-300" />
      )}
      <span className="hidden md:inline text-[10px] font-black uppercase tracking-[.2em]">
        {label}
      </span>
    </button>
  </div>
);

const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 4000);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div className="fixed top-8 left-1/2 -translate-x-1/2 z-[300] px-6 py-3.5 rounded-2xl shadow-2xl flex items-center gap-3 animate-in slide-in-from-top-4 duration-300 bg-red-500 text-white">
      <Icon name="AlertCircle" size={20} />
      <span className="text-sm font-black uppercase tracking-wider whitespace-nowrap">{message}</span>
    </div>
  );
};

const RicambiPage = () => {
  const navigate = useNavigate();
  const [isInsertOpen, setIsInsertOpen] = useState(false);
  const [isRiepilogoOpen, setIsRiepilogoOpen] = useState(false);
  const [isGraficiOpen, setIsGraficiOpen] = useState(false);
  const [isScortaOpen, setIsScortaOpen] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleOpenInsert = async () => {
    setIsChecking(true);
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { setErrorMsg("Devi effettuare il login!"); return; }

      const { data: profil } = await supabase.from('profili').select('ruolo').eq('id', user.id).single();
      if (profil?.ruolo === 'cco-admin' || profil?.ruolo === 'Owner') {
        setIsInsertOpen(true);
      } else {
        setErrorMsg("Non sei autorizzato per questa operazione!");
      }
    } catch (err) {
      setErrorMsg("Errore di connessione!");
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <DashboardHeader />
      {errorMsg && <Toast message={errorMsg} onClose={() => setErrorMsg(null)} />}

      <main className="flex-grow w-full relative">
        <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12 pt-24 md:pt-32 pb-12">
          
          <div className="flex items-center justify-between mb-8 gap-3">
            <button 
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 px-3 py-3 md:px-4 md:py-2 rounded-xl bg-muted/50 hover:bg-muted border border-border/50 transition-all group shadow-sm"
            >
              <Icon name="ArrowLeft" size={18} className="group-hover:-translate-x-1 transition-transform" />
              <span className="hidden md:inline text-[10px] font-black uppercase tracking-widest">Indietro</span>
            </button>

            <div className="flex items-center gap-3">

             {/* SCORTA - Detaljan uvid u zalihe */}
              <ActionButton 
                onClick={() => setIsScortaOpen(true)}
                icon="PackageSearch"
                label="Scorta"
                description="Visualizza scorta dei cilindri"
                colorClass="bg-slate-700 hover:bg-slate-800 shadow-slate-900/20"
              />

              {/* GRAFICI - Statistika i analitika */}
              <ActionButton 
                onClick={() => setIsGraficiOpen(true)}
                icon="BarChart3"
                label="Grafici"
                description="Analisi statistica interventi cilindri"
                colorClass="bg-teal-700 hover:bg-teal-800 shadow-teal-900/20"
              />

              {/* MONITORAGGIO - Real-time stanje na linijama */}
              <ActionButton 
                onClick={() => setIsRiepilogoOpen(true)}
                icon="Activity"
                label="Monitoraggio"
                description="Stato attuale cilindri montati per linee"
                colorClass="bg-emerald-800 hover:bg-emerald-900 shadow-emerald-950/20"
              />

              {/* NUOVO INTERVENTO - Akcija unosa (sa provjerom admin prava) */}
              <ActionButton 
                onClick={handleOpenInsert}
                isLoading={isChecking}
                disabled={isChecking}
                icon="Plus"
                label={isChecking ? "Verifica..." : "Nuovo Intervento"}
                description="Registra un nuovo intervento"
                colorClass="bg-primary hover:bg-primary/90 shadow-primary/20"
              />
            </div>
          </div>

          {/* Glavna tabela sa podacima */}
          <TabellaCilindri key={refreshKey} />
        </div>
      </main>

      

      {/* MODALS */}
      <NewInsert_Cilindri
        isOpen={isInsertOpen} 
        onClose={() => setIsInsertOpen(false)} 
        onRefresh={() => {
          setRefreshKey(prev => prev + 1);
          setIsInsertOpen(false);
        }}
      />

      <LineeOverviewModal 
        isOpen={isRiepilogoOpen}
        onClose={() => setIsRiepilogoOpen(false)}
      />

      <GraficiPanieraModal
        isOpen={isGraficiOpen}
        onClose={() => setIsGraficiOpen(false)}
      />

      <ScortaCilindriModal
        isOpen={isScortaOpen}
        onClose={() => setIsScortaOpen(false)}
      />

      <OrizonFooter />
    </div>
  );
};

export default RicambiPage;